import { gql } from 'apollo-boost'

export const GET_BANK_SLIP_NOTIFICATION = gql`
  query GetBankSlipNotification($input: GetBankSlipNotificationInput!) {
    getBankSlipNotification(input: $input) {
      urlReport
      digitableNumber
    }
  }
`
